export default {"src":"/_next/static/media/verification-image.85ce6854.svg","height":124,"width":124,"blurWidth":0,"blurHeight":0};